import React from 'react'

function OutOfStock() {
    return (
        <span className="button-link-disable">
            Out Of Stock
        </span>
    )
}

export default OutOfStock
